module.exports = __webpack_public_path__ + "static/media/photo5.f3bb02a9.png";